import React from 'react';
import Navigation from '../../components/static/Navigation';
import Footer from '../../components/static/Footer';

import VBDropdown from "@vb-js-commons/new/vbDropdown";


class NHListings extends React.Component {
    constructor() {
        super();
        this.navigation = React.createRef();
        this.state = {
            ddl_options: {
                tag: [],
                country: [],
            },
            filters: {
                tag:null,
                country:null
            }
        }
    }

    componentDidMount(){

        this.state.ddl_options.tag.push("")
        this.state.ddl_options.country.push("")

        Window.react_data.projects.forEach((p) => {
            if(!this.state.ddl_options.tag.includes(p.tag)){
                this.state.ddl_options.tag.push(p.tag)
            } 

            if(!this.state.ddl_options.country.includes(p.country)){
                this.state.ddl_options.country.push(p.country)
            } 
        })
        this.setState({ddl_options: this.state.ddl_options});
    }

    render() {

        let projects = Window.react_data.projects.filter((p) => {
            return Object.keys(this.state.filters).reduce((acum, curr) => {
                let filter_val = this.state.filters[curr];
                if(filter_val && p[curr] != filter_val){
                    return false
                }
                
                return acum;
            }, true)
        })



        return (
            <div>
                <div className="bg-white">
                    <Navigation ref={this.navigation} />
                </div>
                <div className="container neutral-charcoal mt-4">
                    <h1>Våra Projekt</h1>
                    <p>Sök och hitta projekt för att förbättra världen ett steg i taget.</p>
                </div>
                <div className="container neutral-charcoal" style={{marginBottom:"64px"}}>
                    <div className="inline-block mr-2 my-2">
                        <VBDropdown onChange={(val) => {this.setState({filters: {...this.state.filters, tag: val.value}})}} placeholder="Projekts Typ" options={this.state.ddl_options.tag.map((itm) => {return {"value": itm, "label": itm ? itm : "Alla"}})} inputStyle={{ minHeight: 0 }} />
                    </div>
                    <div className="inline-block mr-2 my-2">
                        <VBDropdown onChange={(val) => {this.setState({filters: {...this.state.filters, country: val.value}})}} placeholder="Land" options={this.state.ddl_options.country.map((itm) => {return {"value": itm, "label": itm ? itm : "Alla"}})} inputStyle={{ minHeight: 0 }} />
                    </div>
                </div>

                <div className="container neutral-charcoal mb-4">
                    <div className="flex flex-wrap">
                        {projects.map((p, i) => {
                            return <div style={{cursor:"pointer"}} className="w-full lg:w-1/4 mb-2" onClick={() => {window.location = "/"+ p.attribute_label +"/" + p.id + "/"}}>
                            <div className="rounded-lg border border-neutral-pebble overflow-hidden m-3" style={{height:"416px"}}>
                                <div className="w-full flex justify-center items-center bg-neutral-stone-300" style={{height:"192px"}}>
                                    {p.thumbnail ?
                                        <img className="w-full h-full object-cover" src={p.thumbnail} alt={p.title} />
                                    :   <img className="bg-white p-4 rounded-full overflow-visible " src={Window.static_path + "img/icons/leaf.svg"} style={{width:"100px", height:"100px"}} />}
                                </div>
                                
                                <div className="p-2 relative bg-neutral-cloud-300" style={{height:"224px"}}>
                                    {/* upper half of card in this div */}
                                    <div className="pt-4 absolute top-0" style={{height:"112px"}}>
                                        <div className="mb-4">
                                            <span className="bg-supp-plum white rounded-3xl py-1 px-2 text-[12px] tracking-[-0.12px] max-[768px]:text-[10px] max-[768px]:tracking-[-0.1px]">{p.tag}</span>
                                        </div>
                                        <p className="text-[16px] leading-[125%] tracking-[-0.32px]">{p.title} - {p.property_designation}</p>
                                    </div>
                                    {/* lower half of card in this div */}
                                    <div className="absolute bottom-2 pt-6" style={{height:"112px"}}>
                                        <p className="text-[16px] leading-[125%] tracking-[-0.32px]">{p.project_length} {p.project_length_unit}</p>
                                        <p className="absolute bottom-0 text-[13px] leading-[120%] tracking-[-0.26px]">{p.country}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        })}
                    </div>
                </div>
                
                <Footer/>
            </div >
        )
    }
}
export default NHListings;